export const appInfo = {
  appName: 'Armada admin dashboard',
  apiDomain: import.meta.env.VITE_API_URL!,
  websiteDomain: import.meta.env.VITE_APP_URL!,
  websiteBasePath: '/auth',
  apiBasePath: '/auth',
};
